import { render, staticRenderFns } from "./SchoolPrograms.vue?vue&type=template&id=5172425c&scoped=true&"
import script from "./SchoolPrograms.vue?vue&type=script&lang=js&"
export * from "./SchoolPrograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5172425c",
  null
  
)

export default component.exports